import { useState, useEffect, useCallback } from 'react';
import { miniAppSessionService } from '@/services/miniAppSessionService';

export const useMiniAppSession = (appId: string) => {
  const [hasValidSession, setHasValidSession] = useState(false);

  useEffect(() => {
    const isValid = miniAppSessionService.isSessionValid(appId);
    setHasValidSession(isValid);
  }, [appId]);

  const openApp = useCallback((url: string) => {
    const isValid = miniAppSessionService.isSessionValid(appId);
    
    if (isValid) {
      // Open directly if session is valid
      window.open(url, '_blank');
    } else {
      // First time or expired - open and save session
      const newWindow = window.open(url, '_blank');
      if (newWindow) {
        miniAppSessionService.saveSession(appId);
        setHasValidSession(true);
      }
    }
  }, [appId]);

  const clearSession = useCallback(() => {
    miniAppSessionService.clearSession(appId);
    setHasValidSession(false);
  }, [appId]);

  return {
    hasValidSession,
    openApp,
    clearSession
  };
};
